import React from 'react';
import cn from 'classnames';

const Footer = ({ children, className }) => {
  return <div className={cn('page-footer', className)}>{children}</div>;
};

export default Footer;
